import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Row from 'src/components/10-atoms/layout/Row';
import Pressable from 'src/components/10-atoms/pressables/Pressable';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import styleUtils from 'src/utils/styles';
import useSWUpdate from './hooks/useSWUpdate';
const SWUpdateBanner = () => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { updateAvailable, acceptUpdate, dismiss } = useSWUpdate();
    if (!updateAvailable)
        return null;
    return (React.createElement(Row, { xAxis: "space-between", yAxis: "center", spacingX: theme.spacing.standard.sm, pv: theme.spacing.standard.xs, ph: theme.spacing.standard.sm, bg: theme.palette.background.message },
        React.createElement(Typography, { variant: TypographyVariant.BODY, style: styleUtils.flex }, "A new version is available"),
        React.createElement(Row, { yAxis: "center" },
            React.createElement(Button, { size: "sm", variant: 'text', onPress: acceptUpdate }, "Update"),
            React.createElement(Pressable, { onPress: dismiss },
                React.createElement(FeatherIcon, { name: 'x', size: theme.iconSize.xs, color: theme.palette.icon.primary })))));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default SWUpdateBanner;
